import { useQuery } from "@tanstack/react-query";
import { fetchEmployee } from "../../../../../../enums/queryFunction/Fetch";
import { EMPLOYEE_SINGLE, EMPLOYEES } from "../../../../../../enums/QueryKeys";

export function useGetEmployees(clinic_id) {
  const { data, isLoading, error } = useQuery({
    queryKey: [EMPLOYEES,clinic_id],
    queryFn: () => fetchEmployee(clinic_id),
    staleTime: Infinity,
  });

  return { data, isLoading, error };
}
